module.exports = __webpack_public_path__ + "static/media/outlookLogo.964e47e4.svg";